export default function ServicesHero() {
  return (
    <section className="relative pt-40 pb-24 bg-[#f4f2ef] overflow-hidden">
      <div className="max-w-[1440px] mx-auto px-6 md:px-10">
        <div className="max-w-3xl">
          <div className="flex items-center gap-3 mb-8">
            <div className="w-10 h-px bg-[#b8956a]"></div>
            <span className="text-[#b8956a] text-sm font-medium tracking-[0.2em] uppercase">Our Services</span>
          </div>
          <h1
            className="font-bold text-[#1a1a1a] leading-[1.25] mb-6"
            style={{ fontSize: 'clamp(2rem, 4vw, 2.75rem)' }}
          >
            服務項目
          </h1>
          <p
            className="text-[#5a5a5a] leading-[1.75] max-w-2xl"
            style={{ fontSize: '1.1875rem' }}
          >
            四大服務體系，從策略規劃到工程落地，
            全程整合、一次到位，讓你的商業空間投資真正發揮最大效益。
          </p>
        </div>
      </div>
    </section>
  );
}
